import '@loyal/main.css'

import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { OidcProvider } from 'redux-oidc'
import { ConnectedRouter } from 'connected-react-router'
import { LastLocationProvider } from 'react-router-last-location'
import { HelmetProvider } from 'react-helmet-async'
import { datadogRum } from '@datadog/browser-rum'

import { userManager } from 'Auth'
import AppRouter from 'App/AppRouter'
import HeadMetadata from 'Shared/HeadMetadata'

datadogRum.init({
  applicationId: '88d9dc40-a5a5-4298-aafa-0f0a146cd20d',
  clientToken: 'pubfb4b3f44843d5d78e218b715cfdb0a60',
  site: 'datadoghq.com',
  service: 'ragnarok-webapp-' + process.env.REACT_APP_ENVIRONMENT + '-' + process.env.REACT_APP_TENANT_ID,
  sampleRate: 100,
  trackInteractions: true,
  env: process.env.REACT_APP_TENANT_ID
})

const App = ({ store, history }) => (
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <ConnectedRouter history={history}>
        <LastLocationProvider>
          <HelmetProvider>
            <HeadMetadata />
            <AppRouter />
          </HelmetProvider>
        </LastLocationProvider>
      </ConnectedRouter>
    </OidcProvider>
  </Provider>
)

App.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

export default App



// WEBPACK FOOTER //
// ./src/App/App.js